/*
 * Header cart count sync — only loaded when the theme cart drawer is off.
 *
 * With the drawer rendered, `sht-cart-drwr-frm` answers `cart:update` and re-renders
 * the header cart status alongside the drawer. Without the drawer nothing does, so a
 * Rebuy Smart Cart add or quantity change would leave the header badge stale until
 * the next page load. This listens for the same events and re-renders just the
 * `header-cart-status` section.
 */
(function () {
  'use strict';

  if (window.__shtCartCountSyncBound) return;
  window.__shtCartCountSyncBound = true;

  var SECTION_ID = 'header-cart-status';
  var TARGET = '#headerCartStatus';
  var EVENTS = ['cart:update', 'rebuy:cart.add', 'rebuy:cart.change'];
  /* Rebuy fires add and change back to back — coalesce into one fetch. */
  var DEBOUNCE = 150;

  var timer = null;
  var inFlight = false;
  var again = false;

  function render() {
    if (inFlight) {
      again = true;
      return;
    }
    var target = document.querySelector(TARGET);
    if (!target) return;

    inFlight = true;
    fetch(window.location.pathname + '?section_id=' + SECTION_ID, {
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart status responded ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.shopify-section');
        if (fresh) target.innerHTML = fresh.innerHTML;
      })
      .catch(function (error) {
        console.warn('[cart-count-sync] could not refresh the header cart count', error);
      })
      .then(function () {
        inFlight = false;
        if (again) {
          again = false;
          schedule();
        }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(render, DEBOUNCE);
  }

  EVENTS.forEach(function (name) {
    document.addEventListener(name, schedule);
  });
})();
